import type { AppId } from '@omnia/shared';
import { APPS } from './registry.ts';

/** The calendar tile shows today's date, the one live detail worth putting on an icon. */
export function AppTile({ id, size }: { id: AppId; size: number }) {
  const app = APPS[id];
  return (
    <span
      className="app-tile"
      style={{ width: size, height: size, ['--tone' as string]: `var(${app.tone})` }}
      aria-hidden
    >
      {id === 'calendar' ? (
        <span className="tile-date">
          <span className="tile-date-bar" />
          <span className="tile-date-day" style={{ fontSize: Math.round(size * 0.4) }}>
            {new Date().getDate()}
          </span>
        </span>
      ) : (
        <app.icon size={Math.round(size * 0.46)} strokeWidth={2} />
      )}
    </span>
  );
}
